export const linkTo = {
    signup: (source?: string, target?: string | null) => {
        const params = [];
        if (source) {
            params.push(`source=${source}`);
        }
        if (target) {
            params.push(`target=${target}`);
        }
        const paramString = params.join('&');

        return params.length === 0 ? `/signup` : `/signup?${paramString}`;
    },
    login: (target?: string | null) => `/login${target ? `?target=${target}` : ''}`,
    logout: () => `/logout`,
    forgotPassword: () => `/accounts/resetpassword`,
    privacyPolicy: () => `/legal/privacy`,
    vistaprintPrivacyPolicy: (locale: string) =>
        `https://redirect.account.vistaprint.com/legal?documentId=privacy-policy&culture=${locale}`,
    vistaprintPrivacyPolicyUS: () =>
        `https://www.vistaprint.com/customer-care/privacy-and-security.aspx?txi=16764&xnid=Footer_Privacy+and+Security_Our+Policies&xnav=footer`,
    termsOfUse: () => `/legal/terms-of-use`,
    payoutMethods: () => `/accounts/earnings/payout-methods`,
    authSAMLRedirect: (target?: string | null) =>
        `/accounts/saml/99d${target ? `?target=${target}` : ''}`,
    authOAuthRedirect: (provider: string, target?: string | null, source?: string) =>
        `/oauth/login?provider=${provider}${target ? `&target=${target}` : ''}${
            source ? `&source=${source}` : ''
        }`,
    helpContact: () => '/help/contact',
};
